export function getUrlParams(search = location.search) {
  if (!search) {
    return {};
  }

  try {
    return JSON.parse(
      `{"${decodeURI(search.substring(1))
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')}"}`,
    );
  } catch (err) {
    console.warn('Error on parse url params', err);
    return {};
  }
}
